import { z } from 'zod';

export type CityCreateForm = {
    name: string,
};

export type CityCreateFormErrors = {
    name?: Array<string>,
};

export const CityCreateFormErrorsSchema = z.object({
    name: z.array(z.string()).optional(),
});
